Template from ./templates/progress

Observable from @danielx/observable

type ProgressParams = Partial<{
  value: number
  max: number
  message: string
}>

export Progress := (params: ProgressParams={}) ->
  {value, max, message} := params as any

  model :=
    value: Observable value or 0
    max: Observable max
    message: Observable message
    element: null as! HTMLElement

  model.element = Template model

  return model

export default Progress
